import { useCallback, useEffect, useState } from 'react'
import type { Language } from '../components/SiteHeader'

const STORAGE_KEY = 'vcn:lang'

const read = (): Language => {
  if (typeof window === 'undefined') return 'de'
  const stored = window.localStorage?.getItem(STORAGE_KEY)
  if (stored === 'de' || stored === 'en') return stored
  return navigator.language?.toLowerCase().startsWith('en') ? 'en' : 'de'
}

/**
 * Sprachauswahl der Seite. Merkt sich die Wahl im localStorage und hält
 * `<html lang>` aktuell.
 */
export function useLanguage(): [Language, (next: Language) => void] {
  const [language, setLanguage] = useState<Language>('de')

  // Erst nach dem Mount lesen, damit Server- und Client-Markup identisch sind.
  useEffect(() => setLanguage(read()), [])

  useEffect(() => {
    document.documentElement.lang = language
  }, [language])

  const change = useCallback((next: Language) => {
    setLanguage(next)
    try {
      window.localStorage?.setItem(STORAGE_KEY, next)
    } catch {
      // localStorage kann blockiert sein – die Auswahl gilt dann nur für die Sitzung.
    }
  }, [])

  return [language, change]
}
